import { Outlet, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider';
import {
  LayoutDashboard, Calendar, Radio, Repeat, BarChart3, Bot,
  Users, Settings as Cog, CreditCard, LogOut,
} from 'lucide-react';
import clsx from 'clsx';
import { NPSWidget } from './NPSWidget';

const NAV = [
  { to: '/dashboard', icon: LayoutDashboard, key: 'nav.dashboard' },
  { to: '/content',   icon: Calendar,        key: 'nav.content' },
  { to: '/channels',  icon: Radio,           key: 'nav.channels' },
  { to: '/exchange',  icon: Repeat,          key: 'nav.exchange' },
  { to: '/analytics', icon: BarChart3,       key: 'nav.analytics' },
  { to: '/farm',      icon: Users,           key: 'nav.farm', requiresFarm: true },
  { to: '/bots',      icon: Bot,             key: 'nav.bots' },
  { to: '/settings',  icon: Cog,             key: 'nav.settings' },
  { to: '/billing',   icon: CreditCard,      key: 'nav.billing' },
];

export function Layout(): JSX.Element {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();
  const visibleNav = NAV.filter((n) => !n.requiresFarm || user?.farmEnabled);

  return (
    <div className="flex h-screen bg-slate-50">
      <aside className="w-60 bg-white border-r border-slate-200 flex flex-col">
        <div className="p-4 border-b border-slate-200">
          <div className="text-2xl font-bold text-brand-primary">teleclaw</div>
          <div className="text-xs text-brand-muted mt-1">{user?.plan}</div>
        </div>
        <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
          {visibleNav.map(({ to, icon: Icon, key }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition',
                  isActive
                    ? 'bg-brand-primary text-white'
                    : 'text-brand-ink hover:bg-slate-100',
                )
              }
            >
              <Icon size={18} />
              <span>{t(key)}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-2 border-t border-slate-200">
          <button
            onClick={() => void signOut()}
            className="flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm text-brand-muted hover:bg-slate-100"
          >
            <LogOut size={18} />
            <span>{t('common.signOut')}</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
      <NPSWidget />
    </div>
  );
}
